import { useCallback, useEffect, useRef, useState } from "react"

export function useFormSidebarPositioning(openSectionId: string | null) {
  const [sidebarOffset, setSidebarOffset] = useState(0)
  const accordionRefs = useRef<Record<string, HTMLElement | null>>({})
  const accordionContainerRef = useRef<HTMLDivElement>(null)

  const setAccordionRef = useCallback(
    (id: string) => (element: HTMLDivElement | null) => {
      if (element) {
        accordionRefs.current[id] = element
      }
    },
    [],
  )

  const updateSidebarOffset = useCallback(() => {
    if (!openSectionId || !accordionContainerRef.current) {
      setSidebarOffset(0)
      return
    }

    const containerRect = accordionContainerRef.current.getBoundingClientRect()
    const accordionElement = accordionRefs.current[openSectionId]

    if (accordionElement) {
      const accordionRect = accordionElement.getBoundingClientRect()
      const offset = accordionRect.top - containerRect.top
      setSidebarOffset(Math.max(0, offset))
    } else {
      setSidebarOffset(0)
    }
  }, [openSectionId])

  useEffect(() => {
    const timer = setTimeout(() => {
      updateSidebarOffset()
    }, 250)
    return () => clearTimeout(timer)
  }, [updateSidebarOffset])

  useEffect(() => {
    const handleResize = () => {
      updateSidebarOffset()
    }
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [updateSidebarOffset])

  useEffect(() => {
    const timer = setTimeout(() => {
      updateSidebarOffset()
    }, 100)
    return () => clearTimeout(timer)
  }, [updateSidebarOffset])

  return {
    sidebarOffset,
    accordionContainerRef,
    setAccordionRef,
    accordionRefs,
  }
}
